import React from "react";
function Calendar (){

    const today = new Date();
    const mesiac = today.getMonth() + 1; 
    const den = today.getDate();

    const kalendar1 = [
        "Nový rok", "Alexandra", "Daniela", "Drahoslav", "Andrea", "Antónia",
        "Bohuslava/Róbert", "Severín", "Alexej", "Dá", "Malvána",
        "Ernest", "Rastislav", "Radovan", "Dobroslav", "Kristína",
        "Nataša", "Bohdana", "Drahomíra", "Dalibor", "Vincent", "Zora",
        "Miloš", "Timotej", "Gejza", "Tamara", "Bohuš", "Alfonz",
        "Gašpar", "Ema", "Emil",
        "Tatiana", "Erika/Erik", "Blažej", "Veronika", "Agáta", "Dorota",
        "Vanda", "Zoja", "Zdenko", "Gabriela", "Dezider", "Perla",
        "Arpád", "Valentín", "Pravoslav", "Ida", "Miloslava", "Jaromír",
        "Vlasta", "Lávia", "Eleonóra", "Etela", "Roman/Romana",
        "Matej", "Frederik/Frederika", "Viktor", "Alexander",
        "Zlatica", "",
        "Albín", "Anežka", "Bohumil/Bohumila", "Kazimír", "Fridrich",
        "Radoslav/Radoslava", "Tomáš/Róbert", "Alan/Alana", "Františka",
        "Branislav/Bruno", "Angela/Angelika", "Gregor", "Vlastimil",
        "Matilda", "Svetlana", "Boleslav", "1/4ubica", "Eduard", "Jozef",
        "Vážazoslav", "Blahoslav", "Beo`adik", "Adrián", "Gabriel",
        "Marián", "Emanuel", "Alena", "Soo`a", "Miroslav", "Vieroslava",
        "Benjamín",
        "Hugo", "Zita", "Richard", "Izidor", "Miroslava", "Irena",
        "Zoltán/Róbert", "Albert", "Milena", "Igor", "Július", "Estera",
        "Aleš", "Justína", "Fedor", "Dana/Danica", "Rudolf", "Valér",
        "Jela", "Marcel", "Ervín", "Slavomír", "Vojtech", "Juraj",
        "Marek", "Jaroslava", "Jaroslav", "Jarmila", "Lea",
        "Anastázia",
        "Sviatok práce", "Žigmund", "Galina", "Florián", "Lesana/Lesia", "Hermína",
        "Monika/Róbert", "Ingrida", "Roland", "Viktória", "Blažena",
        "Pankréc", "Servéč", "Bonifíc", "Žofia", "Svetozár", "Gizela",
        "Viola", "Gertrúda", "Bernard", "Zina", "Júlia/Juliana",
        "Želméra", "Ela", "Urban", "Dušan", "Iveta", "Viliam", "Vilma",
        "Ferdinand", "Petronela/Petrana",
        "Žaneta", "Xénia", "Karolína", "Lenka", "Laura", "Norbert",
        "Róbert", "Medard", "Stanislava", "Margaréta", "Dobroslava",
        "Zlatko", "Anton", "Vasil", "Vít", "Blanka", "Adolf", "Vratislav",
        "Alfréd", "Valéria", "Alojz", "Paulína", "Sidínia", "Ján",
        "Tadeáš", "Adriana", "Ladislav/Ladislava", "Beata",
        "Peter/Pavol/Petra", "Melónia",
        "Diana", "Berta", "Miloslav", "Prokop", "", "Patrik/Patrícia",
        "Oliver", "Ivan", "Lujza", "Amália", "Milota", "Nina", "Margita",
        "Kamil", "Henrich", "Drahomír", "Bohuslav", "Kamila", "Dušana",
        "I3/4ja/Elič", "Daniel", "Magdaléna", "O3/4ga", "Vladimír",
        "Jakub", "Anna/Hana", "Božena", "Krištof", "Marta", "Libuša",
        "Ignác",
        "Božidara", "Gustáv", "Jerguš", "Dominik/Dominika", "Hortenzia",
        "Jozefína", "Štefánia", "Oskar", "1/4ubomíra", "Vavrinec",
        "Zuzana", "Darina", "1/4ubomíra", "Mojmír", "Marcela", "Leonard",
        "Milica", "Elena/Helena", "Lídia", "Anabela", "Jana", "Tichomír",
        "Filip", "Bartolomej", "1/4udovýt", "Samuel", "Silvia", "Augustín",
        "Nikola/Nikolaj", "Ružena", "Nora",
        "Drahoslava", "Linda", "Belo", "Rozália", "Regína", "Alica",
        "Marianna", "Miriama", "Martina", "Oleg", "Bystrík"
      ];

      const kalendar2 = [
        "Mária", "Ctibor", "1/4udomil", "Jolana", "1/4udmila", "Olympia",
        "Eugénia", "Konštantín", "1/4uboslav/1/4uboslava", "Matúš", "Márič",
        "Zdenka", "1/4uboš/1/4ubor", "Vladislav", "Edita", "Cyprián",
        "Václav", "Michal/Michaela", "Jarolím",
        "Arnold", "Levoslav", "Stela", "Frantiček", "Viera", "Natália",
        "Eliška", "Brigita", "Dioníz", "Slavomóra", "Valenténa",
        "Maximilián", "Koloman", "Boris", "Terézia", "Vladimíra",
        "Hedviga", "Lukáš", "Kristián", "Vendelín", "Urču3/4a", "Sergej",
        "Alojzia", "Kvetoslava", "Aurel", "Demeter", "Sabéna", "Dobromila",
        "Klára", "Šimon/Simona", "Aurélia",
        "Denis/Denisa", "", "Hubert", "Karol", "Imrich", "Renáta",
        "Rená", "Bohumér", "Teodor", "Tibor", "Martin/Maroš", "Svätopluk",
        "Stanislav", "Irma", "Leopold", "Agnesa", "Klaudia", "Eugen",
        "Alžbeta", "Félix", "Elvíra", "Cecília", "Klement", "Emília",
        "Katarína", "Kornel", "Milan", "Henrieta", "Vratko",
        "Ondrej/Andrej",
        "Edmund", "Bibiána", "Oldrich", "Barbora", "Oto", "Mikulá",
        "Ambróz", "Marána", "Izabela", "Radáz", "Hilda", "Otília",
        "Lucia", "Branislava/Bronislava", "Ivica", "Albína", "Kornália",
        "Sláva/Slávka", "Judita", "Dagmara", "Bohdan", "Adela", "Nadežda",
        "Adam/Eva", "Vianoce", "Štefan", "Filoména", "Ivana/Ivona", "Milada",
        "Dávid", "Silvester"
      ];

      const dniVMesiaci = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      let kalendarIndex = 0;
      for (let i = 0; i < mesiac - 1; i++) {
        kalendarIndex += dniVMesiaci[i];
      }
      kalendarIndex += (den - 1);

      const todayName =
      kalendarIndex - 255 >= 0
        ? kalendar2[kalendarIndex - 255]
        : kalendar1[kalendarIndex];

    return(
    <>
        {todayName}
    </>
    )
};

export default Calendar;